import styled from 'styled-components';
import { getColor } from '../../../src/styled/utils';
export const StyledListItemAction = styled.div `
  position: absolute;
  top: 50%;
  right: 0;
  color: ${getColor('onSurface')};
  transform: translateY(-50%);
`;
